import { ServiceTokens } from "$src/domain/ServiceTokens";
import type { IProjectDraftRepository } from "$src/domain/projects/drafts/IProjectDraftRepository";
import { ProjectDraft } from "$src/domain/projects/drafts/ProjectDraft";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetDraft {
    
    constructor(@inject(ServiceTokens.ProjectDraftRepository) private projectDraftRepository: IProjectDraftRepository) {}

    async execute(groupStoreId: number, projectId: number): Promise<ProjectDraft> {

        return await this.projectDraftRepository.GetDraft(groupStoreId, projectId);
    }
}

export const GetDraftToken = Symbol('GetDraftToken');